import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCoButtonPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" d="M10 1H6v5H1v4h5v5h4v-5h5V6h-5z" />
  </svg>
);
export default SvgCoButtonPlus;
